import React from "react";
import { withTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FcFinePrint } from "react-icons/fc";

const TimelineEmptyState = ({ t, variant = "no-metric" }) => {
  const navigate = useNavigate();

  if (variant === "no-data") {
    return (
      <div className="mat-empty-state" data-testid="mat-empty-no-data">
        <FcFinePrint />
        <span>{t("MetricAnomalyTimeline.noDataInRange.label")}</span>
      </div>
    );
  }

  return (
    <div className="mat-empty-state" data-testid="mat-empty-no-metric">
      <FcFinePrint />
      <span>{t("MetricAnomalyTimeline.noMetricHint.label")}</span>
      <div className="mat-empty-actions">
        <Button variant="outline-primary" size="sm" onClick={() => navigate("../dashboard")}>
          {t("AnomalyDashboard.label")}
        </Button>
        <Button variant="primary" size="sm" onClick={() => navigate("../list")}>
          {t("AnomalyList.label")}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation()(TimelineEmptyState);
